import * as loginActions from './actions';
import { LoginActionTypes, LoginState } from './types';
import { ActionType } from 'typesafe-actions';
import { Reducer } from 'redux';

export type LoginAction = ActionType<typeof loginActions>;

// Type-safe initialState!
const initialState: LoginState = {
  userId: 0,
  username: '',
  password: '',
  parentPartyDibCode: '',
  parentPartyName: '',
  parentPartyId: 0,
  errorMessage: '',
  showLoader: false,
  mfaCode: '',
  useMfa: false,
  mfaQRCode: '',
  registeredMfa: false,
  accessToken: ''
};

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<LoginState, LoginAction> = (state = initialState, action): LoginState => {
  switch (action.type) {
    case LoginActionTypes.LOG_IN_REQUEST_OKTA:
    case LoginActionTypes.LOG_IN_REQUEST:
      return { ...state, showLoader: true };
    case LoginActionTypes.LOG_IN_SUCCESS:
      return {
        ...state,
        userId: action.payload.data.id,
        username: action.payload.data.username,
        password: action.payload.data.password,
        parentPartyName: action.payload.data.parentPartyName,
        parentPartyDibCode: action.payload.data.parentPartyDibCode,
        parentPartyId: action.payload.data.parentPartyId,
        errorMessage: '',
        useMfa: action.payload.data.useMfa,
        showLoader: false,
        mfaQRCode: action.payload.data.mfaQRCode,
        registeredMfa: action.payload.data.registeredForMfa,
      };
    case LoginActionTypes.MFA_FAIL:
    case LoginActionTypes.LOG_IN_FAIL:
      return {
        ...state,
        userId: 0,
        username: '',
        password: '',
        parentPartyDibCode: '',
        parentPartyName: '',
        parentPartyId: 0,
        errorMessage: action.payload.message,
        showLoader: false,
        mfaCode: '',
        useMfa: false,
        mfaQRCode: '',
        registeredMfa: false
      };
    case LoginActionTypes.MFA_SUCCESS:
      return {
        ...state,
        userId: action.payload.data.id,
        username: action.payload.data.username,
        password: action.payload.data.password,
        parentPartyName: action.payload.data.parentPartyName,
        parentPartyDibCode: action.payload.data.parentPartyDibCode,
        parentPartyId: action.payload.data.parentPartyId,
        errorMessage: action.payload.data.refreshToken === '' ? 'Incorrect MFA token' : '',
        useMfa: action.payload.data.useMfa,
        showLoader: false,
        mfaQRCode: action.payload.data.mfaQRCode,
        registeredMfa: action.payload.data.registeredForMfa
      };
    case LoginActionTypes.CONFIRM_NEW_PASSWORD_FAIL:
      return { ...state, errorMessage: action.payload.message };
    case LoginActionTypes.CHANGE_PASSWORD:
      return { ...state, errorMessage: '', showLoader: false };
    case LoginActionTypes.UPDATE_PASSWORD:
      return { ...state, showLoader: true };
    case LoginActionTypes.UPDATE_PASSWORD_FAIL:
      return { ...state, errorMessage: action.payload.message, showLoader: false };
    case LoginActionTypes.UPDATE_PASSWORD_SUCCESS:
      return { ...state, showLoader: false };
    case LoginActionTypes.OKTA_TOKEN_REQUEST:
      return { ...state, showLoader: true, errorMessage: '' };
    case LoginActionTypes.OKTA_TOKEN_SUCCESS:
      return { ...state, showLoader: false, accessToken: action.payload.accessToken };
    case LoginActionTypes.OKTA_TOKEN_FAILURE:
      return { ...state, showLoader: false, errorMessage: action.payload.error };
    default:
      return state;
  }
};

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export { reducer as loginReducer, initialState as loginInitialState };
